/**
 * @module core/util/actions
 */
const NAMESPACE = 'util';

const UTIL_SAVE_TIMEOUT = 'UTIL_SAVE_TIMEOUT';
const UTIL_DELETE_TIMEOUT = 'UTIL_DELETE_TIMEOUT';

export { NAMESPACE, UTIL_SAVE_TIMEOUT, UTIL_DELETE_TIMEOUT };
